import { Component, effect, inject, OnInit } from '@angular/core';
import { TrackData } from '@shared/interfacres/track';
import { MatProgressBar } from '@angular/material/progress-bar';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell, MatHeaderCellDef,
  MatRow, MatRowDef, MatTable
} from '@angular/material/table';
import { MatIcon } from '@angular/material/icon';
import { PlayerSourceService } from '@shared/components/player-bar/player-source.service';
import { LibraryStore } from '@data-access/user/stores/library.store';
import { saveToFs } from '@shared/helpers/files.helper';
import { NgClass } from '@angular/common';
import { DemoUserHandler } from '@shared/services/demo-user-handler';

@Component({
  selector: 'app-top-tracks',
  imports: [
    MatProgressBar,
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatIcon,

    MatRow,
    MatRowDef,
    MatTable,
    MatHeaderCellDef,
    NgClass
  ],
  templateUrl: './top-tracks.html',
  styleUrl: './top-tracks.scss'
})
export class TopTracks implements OnInit {
  displayedColumns: string[] = ['id', 'name', 'actions'];
  dataSource: Partial<TrackData>[] = [];
  playerSource = inject(PlayerSourceService);

  readonly demoUserHandlerService = inject(DemoUserHandler);
  readonly store = inject(LibraryStore);

  constructor() {
    effect(() => {
      this.dataSource = this.store.topTracks();
    });
  }

  ngOnInit() {
    this.store.getTopTracks();
  }

  play(index: number, track: TrackData) {
    this.playerSource.init(false);
    if (this.playerSource.currentTrack() && this.playerSource.currentTrack()?.id === track.id) {
      // track pressed again
      if (this.playerSource.isPlaying()) {
        this.playerSource.pause();
      } else {
        this.playerSource.play();
      }

      return;
    }
    this.playerSource.setTracksList(this.dataSource, index, true);
  }

  async download(track: TrackData) {
    const isUserValid = await this.demoUserHandlerService.isUserValid();

    if (!isUserValid) {
      return;
    }
    if (track.downloadsCount && track.downloadsCount > 2) {
      return;
    }
    if (this.store.downloadsLeft() < 1) {
      return;
    }
    this.store.increaseTrackCounter(track.id!);
    this.store.increaseTopTrackCounter(track.id!);
    const directLink =  await this.store.getDownloadUrl(track.id!);

    if (directLink) {
      saveToFs(directLink, track.title);
    } else {
      this.store.decreaseTrackCounter(track.id);
      this.store.decreaseTopTrackCounter(track.id);
    }
  }
}
